import React, { FunctionComponent } from 'react';

import { Spinner } from 'app/components/spinner';

export const LogoutPage: FunctionComponent = () => <Spinner />;
